import medal from "assets/images/medal.svg"
import { IconCertified } from "materia"
import { useTranslation } from "react-i18next"
import { modifiers } from "ui-tools"

import s from "./styles.module.scss"

type ConfettiBannerProps = {
  progressType: "high_score" | "certified" | undefined
  progressValue?: number
  productTitle: string | null
}
export const ConfettiBanner = ({
  progressType,
  progressValue,
  productTitle,
}: ConfettiBannerProps) => {
  const { t } = useTranslation()

  const isHighScoreType = progressType === "high_score"

  const getIcon = () => {
    if (isHighScoreType) {
      return <img src={medal} alt="" />
    }
    return <IconCertified size="large" />
  }

  const getLabel = () => {
    if (isHighScoreType) {
      return `${progressValue} ${t("winningBox.PRODUCT_SIM_SCORE")}`
    }
    return t("winningBox.PRODUCT_NONSIM_COMPLETED")
  }

  return (
    <div className={modifiers(s, "banner", progressType)}>
      <div className={s.banner__icon}>{getIcon()}</div>
      <div className={s.banner__details}>
        <div className={s.banner__label}>{getLabel()}</div>
        <div className={s.banner__title}>{productTitle}</div>
      </div>
    </div>
  )
}
